import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyADdvmC72iBGvK_exwQ2fwQe5rWOiSrTSQ",
  authDomain: "production-servers-magnumtires.firebaseapp.com",
  databaseURL: "https://production-servers-magnumtires.firebaseio.com",
  projectId: "production-servers-magnumtires",
  storageBucket: "production-servers-magnumtires.appspot.com",
  messagingSenderId: "916208936979",
  appId: "1:916208936979:web:b50655a11f8670142e37e6",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

setPersistence(auth, browserLocalPersistence)
  .then(() => console.log("✅ Persistência da sessão ativada"))
  .catch((error) => console.error("❌ Erro ao definir persistência:", error));

/**
 * DEBUG: expõe o auth globalmente em ambiente de dev
 * Assim você pode rodar:   magAuth.currentUser   no console.
 */
if (typeof window !== "undefined") {
  window.magAuth = auth;
}

export { auth };
